import { COLORS } from "modules/homeAlt/components/ColorPalette/constants";

export const handleProcessedColors = () => {
  return COLORS.map(({ node }) => node);
};
